import { useNavigate, useLocation } from "react-router-dom";
import dummy from "../../../assets/images/dummy.png";
import Icon from "../../../components/common/Icon";
import {
  BsArrowBarLeft,
  BsChatLeftHeart,
  BsChevronBarLeft,
  BsChevronCompactLeft,
  BsEnvelopeFill,
} from "react-icons/bs";
import { RiMenuUnfold3Fill } from "react-icons/ri";
import { FiArrowLeft } from "react-icons/fi";
import { IoMdArrowRoundBack } from "react-icons/io";
const ParentTopBar = ({ notifications, onMenuClick, goBack }) => {
  const navigate = useNavigate();
  const location = useLocation();
  let loggedInUser = localStorage.getItem("loggedInUser");
  let countRaw = localStorage.getItem("unreadMessagesCount");
  let count = 0;

  try {
    if (countRaw && countRaw !== "undefined" && countRaw !== "null") {
      count = JSON.parse(countRaw);
    }
  } catch {
    count = 0;
  }

  if (
    loggedInUser &&
    loggedInUser !== undefined &&
    loggedInUser !== "undefined"
  ) {
    loggedInUser = JSON.parse(loggedInUser);
  }
  // Check if current path is notifications page
  const isNotificationsPage = location.pathname === "/account/notifications";

  return (
    <div className="w-full lg:min-h-[141px] flex items-start lg:items-center justify-between px-4 xl:px-12 py-2 bg-[#DEE2DD]/50 rounded-[15px] mb-6">
      <div className="flex flex-col items-start justify-between  w-[50px] md:w-auto">
        <div className="pe-2 flex items-end justify-start text-21pt xl:hidden">
          <RiMenuUnfold3Fill
            className="w-8 h-8 lg:w-[33px] lg:h-[32px] mt-2 lg:me-6 hover:text-green cursor-pointer"
            onClick={onMenuClick}
          />
        </div>

        <div
          title="Click to go back"
          className={`pe-2 xxs:mt-8 lg:mt-8 xl:mt-0  flex items-center text-base justify-start text-21pt cursor-pointer hover:text-green ${
            goBack ? "flex" : "opacity-0"
          }`}
          onClick={() => navigate(-1)}
        >
          <IoMdArrowRoundBack className="w-8 h-8 lg:w-[30px] lg:h-[28px]  me-2  cursor-pointer" />
          <span className="hidden text-nowrap xs:flex">Go back</span>
        </div>
      </div>

      <div className="flex lg:items-center items-end flex-col-reverse lg:flex-row">
        <div className="mt-4 lg:mt-0 lg:me-20 pe-2 flex items-end justify-end text-21pt">
          {/* <Icon
            icon="message"
            title="Click to chat"
            className="w-8 h-8 lg:w-[33px] lg:h-[32px] me-6 hover:text-green cursor-pointer"
          /> */}
          <div
            className="relative cursor-pointer"
            title="Click to view notifications"
            onClick={() => navigate("/account/notifications")}
          >
            <BsEnvelopeFill
              className={`w-8 h-8 lg:w-[33px] lg:h-[32px] ${
                isNotificationsPage ? "text-green" : ""
              }`}
            />
            {count > 0 && (
              <div className="absolute w-[12px] h-[12px] rounded-full bg-orange top-0 -right-1"></div>
            )}
          </div>
        </div>
        <div className="flex flex-row lg:items-center ">
          <div className="me-3 lg:me-8 flex flex-col items-end justify-end text-21pt">
            <p className="text-orange">Welcome</p>
            <p className="text-18pt lg:text-21pt text-nowrap max-w-[180px] md:max-w-[350px] truncate overflow-hidden text-ellipsis">
              {loggedInUser?.firstName} {loggedInUser?.lastName}
            </p>
          </div>
          <div className="rounded-full overflow-hidden bg-gray w-[44px] h-[44px] xs:w-[64px] xs:h-[64px] lg:w-[124px] lg:h-[124px]">
            <img
              src={
                loggedInUser?.image
                  ? process.env.REACT_APP_BACKEND_URL +
                    "public/" +
                    loggedInUser?.image
                  : dummy
              }
              onError={(e) => {
                e.currentTarget.src = require("../../../assets/images/dummy.png");
              }}
              className="w-[44px] h-[44px] xs:w-[64px] xs:h-[64px] lg:w-[124px] lg:h-[124px]  object-contain"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ParentTopBar;
